import { supabase } from './supabase';
import { getProductoresCache, saveProductoresCache } from './offline/offlineDb';

// Lectura: se apoya en la policy RLS "encargados ven sus productores
// asignados" (public.encargado_productor JOIN encargados por auth.uid()) —
// no hace falta Edge Function para que un encargado vea sus propios
// productores, igual que productosAplicacion.js.
export async function listarMisProductores() {
  const { data, error } = await supabase.from('productores').select('id, nombre').order('nombre', { ascending: true });

  if (error) {
    return { ok: false, productores: [] };
  }

  return { ok: true, productores: data ?? [] };
}

// Combina red + cache local (IndexedDB) para que el selector de Productor
// de Aplicaciones/Fertilizantes funcione también sin conexión, igual que
// obtenerCatalogoProductosAplicacion. Particionado por auth_user_id
// (ver services/offline/offlineDb.js).
export async function obtenerMisProductoresAsignados(authUserId) {
  const online = await listarMisProductores();
  if (online.ok && online.productores.length > 0) {
    if (authUserId) saveProductoresCache(authUserId, online.productores).catch(() => {});
    return online;
  }

  let cached = null;
  if (authUserId) {
    try {
      cached = await getProductoresCache(authUserId);
    } catch {
      cached = null;
    }
  }

  if (cached && cached.length > 0) {
    return { ok: true, productores: cached };
  }

  return online;
}
